<template>
  <div class="floating" data-testid="time-off-bulk-actions">
    <a-modal
      width="600px"
      title="Time Offs Approval"
      v-model="visibleSignModal"
      @cancel="cancelSignModal"
      :destroy-on-close="true"
      data-testid="time-off-bulk-approval-modal"
    >
      <signature
        checkbox-label="I've reviewed the time off request and confirm the selected days"
        ref="signatureRef"
        test-id="time-off-bulk-signature"
        checkbox-wrapper-test-id="time-off-bulk-signature-checkbox-wrapper"
        checkbox-test-id="time-off-bulk-signature-checkbox"
        canvas-container-test-id="time-off-bulk-signature-canvas-container"
        canvas-element-test-id="time-off-bulk-signature-canvas"
        clear-button-test-id="time-off-bulk-signature-clear-button"
        undo-button-test-id="time-off-bulk-signature-undo-button"
        @checked="checked = $event"
        @save-signature="setSignatureId"
      />

      <template slot="footer">
        <div class="flex justify-content-between" data-testid="time-off-bulk-approval-footer">
          <a-button @click="cancelSignModal" data-testid="time-off-bulk-approval-cancel-button">Cancel</a-button>
          <a-button
            @click="type === 'decline' ? decline() : accept()"
            type="primary"
            :loading="loadingAccept || loadingDecline"
            data-testid="time-off-bulk-approval-save-button"
            >Save</a-button
          >
        </div>
      </template>
    </a-modal>

    <div class="flex align-items-center justify-content-between gap-4">
      <b data-testid="time-off-bulk-selected-count">Selected Time Offs: {{ ids.length }} </b>
      <div class="flex gap-2" data-testid="time-off-bulk-controls">
        <a-button
          type="danger"
          @click="deleteSelected"
          :loading="loadingDelete"
          data-testid="time-off-bulk-delete-button"
        >
          Delete
        </a-button>
        <a-button
          type="danger"
          @click="openSignModal('decline')"
          :disabled="loadingDelete"
          data-testid="time-off-bulk-deny-button"
        >
          Deny
        </a-button>
        <a-button
          type="primary"
          @click="openSignModal('accept')"
          :disabled="loadingDelete"
          data-testid="time-off-bulk-accept-button"
        >
          Accept
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import Signature from '@/components/signature.vue'
import { Button, Modal, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions } = createNamespacedHelpers('timeOff')

export default {
  components: {
    'a-modal': Modal,
    'a-button': Button,
    Signature
  },
  props: {
    ids: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loadingDecline: false,
      loadingAccept: false,
      loadingDelete: false,

      visibleSignModal: false,

      checked: false,
      signature_id: undefined,

      type: undefined
    }
  },
  methods: {
    ...mapActions(['approveTimeOffs', 'declineTimeOffs', 'deleteTimeOffs']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    setSignatureId(signatureId) {
      this.signature_id = signatureId
    },

    openSignModal(type) {
      this.type = type
      this.visibleSignModal = true
    },
    cancelSignModal() {
      this.type = undefined
      this.signature_id = undefined
      this.checked = false
      this.visibleSignModal = false
    },

    async accept() {
      this.loadingAccept = true

      try {
        await this.$refs.signatureRef.saveSignature()

        if (!this.signature_id) return

        const payload = {
          ids: this.ids,
          signature: this.signature_id
        }

        const results = await this.approveTimeOffs(payload)
        const approvedCount = results.filter(item => item.approved).length
        const manualReviewCount = results.filter(item => !item.approved && item.manual_review_required).length

        this.showNotification(
          'success',
          'Success',
          `${approvedCount} request${approvedCount === 1 ? '' : 's'} approved. ${manualReviewCount} require manual payment review.`
        )

        this.cancelSignModal()
        this.$emit('update')
      } catch (error) {
        this.showNotification('error', 'Error', error.message || error)
      } finally {
        this.loadingAccept = false
      }
    },

    async decline() {
      this.loadingDecline = true

      try {
        await this.$refs.signatureRef.saveSignature()

        if (!this.signature_id) return

        const payload = {
          ids: this.ids,
          signature: this.signature_id
        }

        await this.declineTimeOffs(payload)

        this.showNotification('success', 'Success', 'Time offs declined successfully')
        this.cancelSignModal()
        this.$emit('update')
      } catch (error) {
        this.showNotification('error', 'Error', error.message || error)
      } finally {
        this.loadingDecline = false
      }
    },

    async deleteSelected() {
      this.loadingDelete = true

      try {
        const payload = {
          ids: this.ids
        }

        await this.deleteTimeOffs(payload)

        this.showNotification('success', 'Success', 'Time offs deleted successfully')

        this.$emit('update')
      } catch (error) {
        this.showNotification('error', 'Error', error.message || error)
      } finally {
        this.loadingDelete = false
      }
    }
  }
}
</script>

<style scoped>
.floating {
  padding: 20px;
  bottom: 100px;
  position: absolute;
  z-index: 1000;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  left: 50%;
  transform: translateX(-50%);
  min-width: 400px;
  border-radius: 12px;
}
</style>
